/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".time-grid[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding-left:0;padding-right:0}.time-grid[_ngcontent-%COMP%]   .time-slice[_ngcontent-%COMP%]{margin-top:-4px;height:28px}.time-grid[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{position:relative}.time-line[_ngcontent-%COMP%]{position:absolute;left:-1px;top:0;border-left:1px solid red;height:800px}.infoScreenHeader[_ngcontent-%COMP%]{line-height:1.875rem}.infoScreenHeader[_ngcontent-%COMP%]   .h3[_ngcontent-%COMP%]{margin-bottom:0}"];
export { styles as styles };
